import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

const FooterTrustMarkersContext = createContext(null)

export const FooterTrustMarkersProvider = ({
  footerTrustMarkersCombination = null,
  children,
}) => (
  <FooterTrustMarkersContext.Provider value={footerTrustMarkersCombination}>
    {children}
  </FooterTrustMarkersContext.Provider>
)

FooterTrustMarkersProvider.propTypes = {
  footerTrustMarkersCombination: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export const useFooterTrustMarkersCombination = () =>
  useContext(FooterTrustMarkersContext)
